import { render, staticRenderFns } from "./adForm.vue?vue&type=template&id=84a22c64&scoped=true"
import script from "./adForm.vue?vue&type=script&lang=js"
export * from "./adForm.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./adForm.vue?vue&type=style&index=1&id=84a22c64&prod&lang=scss&scoped=true"
import style2 from "./adForm.vue?vue&type=style&index=2&id=84a22c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a22c64",
  null
  
)

export default component.exports